import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MyPlayers from "../Team/components/MyPlayers";
import { loaderStateFalse, loaderStateTrue } from '../../slices/mainSlice';
import { getMatchListApi } from './MatchController';
import { getPlayerListApi } from '../Team/TeamController';

const UpcomingMatches = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { language } = useSelector((state) => state.language);
	const { userDetails, token, userType } = useSelector((state) => state.user);
	console.log("userDetailsuserDetailsuserDetails", userDetails)
	const [matchList, setMatchList] = useState([]);
	const [playerList, setPlayerList] = useState([]);

	useEffect(() => {
		getMatchList();
		getPlayerList();
	}, []);

	const getMatchList = () => {
		try {
			dispatch(loaderStateTrue());
			getMatchListApi()
				.then((response) => {
					let responseData = response.data?.result || [];
					console.log("responseDataresponseDataresponseData", responseData)
					setMatchList(responseData);
					dispatch(loaderStateFalse());
				})
				.catch((error) => {
					console.log(error);
					dispatch(loaderStateFalse());
				});
		} catch (error) {
			console.log(error);
			dispatch(loaderStateFalse());
		}
	};

	const getPlayerList = () => {
		try {
			dispatch(loaderStateTrue());
			getPlayerListApi()
				.then((response) => {
					let responseData = response.data || [];
					setPlayerList(responseData);
					dispatch(loaderStateFalse());
				})
				.catch((error) => {
					console.log(error);
					dispatch(loaderStateFalse());
				});
		} catch (error) {
			console.log(error);
			dispatch(loaderStateFalse());
		}
	};

	console.log("matchListmatchListmatchListmatchListmatchList", matchList)

	const upcomingMatches = [
		{
			time: "12:30",
			date: "26 Aug",
			teams: [
				{
					name: "Paris Saint-Germain",
					logo: require("../../assets/images/clubs/paris.png"),
				},
				{
					name: "Stade Brestois 29",
					logo: require("../../assets/images/clubs/sb29.png"),
				},
			],
			venue: "Stade de France",
			chartIcon: "../../assets/images/icons/bar-chart.svg",
		},
		{
			time: "14:00",
			date: "27 Aug",
			teams: [
				{
					name: "Racing Club de Lens",
					logo: require("../../assets/images/clubs/rcl.png"),
				},
				{
					name: "Olympique Lyonnais",
					logo: require("../../assets/images/clubs/rfef.png"),
				},
			],
			venue: "Stade de France",
			chartIcon: "../../assets/images/icons/bar-chart.svg",
		},

		{
			time: "18:00",
			date: "28 Aug",
			teams: [
				{
					name: "Olympique de Marseille",
					logo: require("../../assets/images/clubs/fff.png"),
				},
				{
					name: "AS Monaco",
					logo: require("../../assets/images/clubs/paris.png"),
				},
			],
			venue: "Stade de France",
			chartIcon: "../../assets/images/icons/bar-chart.svg",
		},
		{
			time: "20:45",
			date: "29 Aug",
			teams: [
				{
					name: "LOSC Lille",
					logo: require("../../assets/images/clubs/paris.png"),
				},
				{
					name: "FC Nantes",
					logo: require("../../assets/images/clubs/rfef.png"),
				},
			],
			venue: "Stade de France",
			chartIcon: "../../assets/images/icons/bar-chart.svg",
		},
		{
			time: "16:00",
			date: "30 Aug",
			teams: [
				{
					name: "Stade Rennais FC",
					logo: require("../../assets/images/clubs/fff.png"),
				},
				{
					name: "OGC Nice",
					logo: require("../../assets/images/clubs/paris.png"),
				},
			],
			venue: "Stade de France",
			chartIcon: "../../assets/images/icons/bar-chart.svg",
		},
	];


	return (
		<main className="main p-4 relative">
			<div className="flex flex-col">
				<div className="flex flex-wrap items-start gap-y-6 -mx-2">
					<div className="lg:w-4/6 w-full px-2">
						<div className="space-y-5">
							<div className="flex justify-between items-center gap-3">
								<h3 className="xl:text-2xl text-xl font-extrabold uppercase">{t('league1Ranking')}</h3>
								<select className="form-select font-bold !max-w-[200px]">
									<option value="">{t('season')} 2025/25</option>
									<option value="">{t('season')} 2025/25</option>
								</select>
							</div>
							<div className="relative text-white">
								<div className="rounded-xl absolute inset-0 bg-gradient-to-b from-[#1B3594] to-[#1A215A] overflow-hidden">
									<div className="absolute -skew-x-[20deg] w-[14vw] top-0 -right-12 bottom-0 bg-[#1B3594] before:content-[''] before:absolute before:w-1/3 before:top-0 before:right-0 before:bottom-0 before:bg-black/10"></div>
								</div>
								<div className="relative bg-cover bg-no-repeat bg-center h-full">
									<div className="flex max-sm:flex-wrap">
										<div className="p-5 flex flex-col items-start justify-between [&_h1_strong]:text-primary-500 space-y-3 md:w-2/3 [&_strong]:text-primary-500">
											<div className="h-full flex flex-col items-start gap-y-2">
												<img src="assets/images/league1m.png" alt="" />
												<h4 className="lg:text-3xl md:text-2xl text-xl font-bold uppercase">{userDetails?.team?.name}</h4>
												<ul className="flex flex-wrap gap-1 md:!mt-auto">
													<li className="px-3 py-1 border border-white/30 text-xs rounded-full font-secondary font-bold">
														<span className="opacity-50">1 x</span> 5.50
													</li>
													<li className="px-3 py-1 border border-white/30 text-xs rounded-full font-secondary font-bold">
														<span className="opacity-50">x</span> 3.25
													</li>
													<li className="px-3 py-1 border border-white/30 text-xs rounded-full font-secondary font-bold">
														<span className="opacity-50">2 x</span> 2.13
													</li>
												</ul>
											</div>
										</div>
										<div className="md:w-1/3 lg:-mt-4 text-center pb-5">
											<img src="assets/images/clubs/paris.png" alt="" className="w-full max-w-56 inline-block" />
										</div>
									</div>
								</div>
							</div>
							<div class="overflow-x-auto">
								<table class="table table-row-hover w-full">
									<thead class="border-b light-border">
										<tr>
											<th>{t("time")}</th>
											<th>{t("teams")}</th>
											<th>{t("venue")}</th>
											<th></th>
										</tr>
									</thead>
									<tbody class="divide-y divide-gray-200 [&_tr_td]:align-top">
										{matchList && matchList?.map((match, index) => {
											return (
												<tr key={index}
													onClick={() => navigate(`/${language}/fixtures/information`)}
													className='cursor-pointer'
												>
													<td width="24">
														<p className="time text-xs font-secondary text-nowrap">
															{match?.matchTime}
														</p>
														<p className="date text-xs font-secondary text-nowrap text-gray-500">
															{match?.matchDate}
														</p>
													</td>
													<td>
														<div
															className="flex max-sm:flex-wrap items-center gap-3"
														// onClick={() => navigate(`/${language}/fixtures/history`)}
														>
															<ul className="flex -space-x-2 rtl:space-x-reverse">
																{match.teams.map((team, teamIndex) => (
																	<li
																		key={teamIndex}
																		className="p-1 size-10 flex justify-center items-center border border-primary-200 rounded-full bg-white"
																	>
																		<img
																			className="size-7 object-contain dark:border-gray-800"
																			src={team?.logo}
																			alt={team?.name}
																		/>
																	</li>
																))}
															</ul>
															<div>
																<p className="uppercase">{match?.teams[0]?.name}</p>
																<p className="uppercase text-gray-400">
																	{match?.teams[1]?.name}
																</p>
															</div>
														</div>
													</td>
													<td>
														<p className="font-secondary uppercase">
															{match?.venue}
														</p>
													</td>
													<td>
														<img
															className="size-7 object-contain dark:border-gray-800"
															src={match?.chartIcon || "../../assets/images/icons/bar-chart.svg"}
															alt="Chart Icon"
														/>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div className="lg:w-2/6 w-full px-2">
						<MyPlayers playerList={playerList}/>
					</div>
				</div>
			</div>
		</main>
	)
}

export default UpcomingMatches